var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPt003ColorDiamond(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "python_color_diamond",
    transform: "translate(-500 -1320)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_987",
    "data-name": "Rectangle 987",
    transform: "translate(500 1368) rotate(-45)",
    fill: "#e6ecff",
    stroke: "#093ce9",
    strokeWidth: 8
  }, /*#__PURE__*/React.createElement("rect", {
    width: 67.882,
    height: 67.882,
    rx: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 59.882,
    height: 59.882,
    rx: 4,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "data_science-python",
    transform: "translate(528.244 1348.244)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_62",
    "data-name": "Group 62"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_46",
    "data-name": "Rectangle 46",
    width: 40,
    height: 40,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_401",
    "data-name": "Group 401",
    transform: "translate(3.284 3.337)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M529.218,49.723a5.019,5.019,0,0,0-3.453-1.432h-.935V47.3a4.463,4.463,0,0,0-1.112-3.185c-1.465-1.707-4.145-2.573-7.968-2.573-3.86,0-6.517.81-7.9,2.407a3.746,3.746,0,0,0-.973,2.667v2.758h-1.18a5.71,5.71,0,0,0-4.08,1.462,9.517,9.517,0,0,0-2.57,7.405c0,3.56.843,6.155,2.5,7.717a5.1,5.1,0,0,0,3.357,1.433.878.878,0,0,0,.1,0h.932v1a4.458,4.458,0,0,0,1.11,3.185c1.465,1.707,4.145,2.573,7.968,2.573,3.86,0,6.518-.81,7.9-2.408a3.727,3.727,0,0,0,.973-2.667V66.318h1.18a5.687,5.687,0,0,0,4.082-1.462,9.515,9.515,0,0,0,2.57-7.4C531.725,53.88,530.881,51.283,529.218,49.723ZM505.91,64.057h-1a1.9,1.9,0,0,1-1.067-.532,7.487,7.487,0,0,1-1.453-5.285,6.7,6.7,0,0,1,1.417-4.882,2.432,2.432,0,0,1,1.608-.667h.04l10.438.012V49.37h-5.677V46.442c.025-.333,1.043-1.563,5.547-1.563,3.57,0,4.9.833,5.377,1.342a1.332,1.332,0,0,1,.39.76l-.033,6.89a3,3,0,0,1-.033.312,2.683,2.683,0,0,1-.645,1.39,1.871,1.871,0,0,1-.666.4,2.65,2.65,0,0,1-.315.088,3.322,3.322,0,0,1-.575.08l-.187.01H511.8c-.21,0-.373.042-.567.057l-.1.01a5.833,5.833,0,0,0-2.982,1.052,4.9,4.9,0,0,0-2.1,3.5,6.581,6.581,0,0,0-.143,1.35Zm21.065-1.728a2.372,2.372,0,0,1-1.647.667h0l-10.438-.01v3.333h5.667l.011,2.928c-.025.333-1.043,1.563-5.548,1.563-3.57,0-4.9-.842-5.377-1.342a1.334,1.334,0,0,1-.388-.758l.02-6.895a2.789,2.789,0,0,1,.042-.392,2.641,2.641,0,0,1,.623-1.3,1.893,1.893,0,0,1,.677-.415,2.691,2.691,0,0,1,.3-.087,3.518,3.518,0,0,1,.6-.085h7.453c.167,0,.29-.037.443-.045.117-.008.253-.022.413-.042a5.777,5.777,0,0,0,2.79-1.032,5.043,5.043,0,0,0,.666-.555,5.217,5.217,0,0,0,1.43-2.938,6.417,6.417,0,0,0,.142-1.35V51.623h1a1.91,1.91,0,0,1,1.067.533,7.484,7.484,0,0,1,1.453,5.287,6.694,6.694,0,0,1-1.4,4.878Z",
    transform: "translate(-499.006 -41.545)",
    fill: "#093ce9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M510.928,59.445a1.318,1.318,0,1,0-.934-.386A1.32,1.32,0,0,0,510.928,59.445Z",
    transform: "translate(-491.937 -31.372)",
    fill: "#093ce9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M507.649,44.219a1.318,1.318,0,1,0,.934.386A1.32,1.32,0,0,0,507.649,44.219Z",
    transform: "translate(-494.123 -39.762)",
    fill: "#093ce9"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPt003ColorDiamond);
export default __webpack_public_path__ + "static/media/PT003_color_diamond.d5b1aa4fe667f00c1224aaf7ed8f93db.svg";
export { ForwardRef as ReactComponent };